"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionMoreActions = /** @class */ (function (_super) {
    __extends(TableActionMoreActions, _super);
    function TableActionMoreActions(props) {
        return _super.call(this, props) || this;
    }
    TableActionMoreActions.prototype.buttonClick = function () {
        if (this.props.onClick) {
            this.props.onClick();
        }
    };
    TableActionMoreActions.prototype.render = function () {
        return (React.createElement(antd_1.Tooltip, { placement: "bottom", title: React.createElement("div", null, this.props.hint), trigger: "hover" },
            React.createElement(antd_1.Dropdown, { overlay: this.props.menu, trigger: ['click'] },
                React.createElement(antd_1.Button, { shape: "circle", size: "small", icon: "down", ghost: true, type: "primary", style: { marginLeft: "1px", marginRight: "1px" }, onClick: this.buttonClick.bind(this) }))));
    };
    return TableActionMoreActions;
}(React.Component));
exports.default = TableActionMoreActions;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/table_actions/TableActionMoreActions.tsx
// module id = 100
// module chunks = 0